export default {
	list: []
};



// WEBPACK FOOTER //
// ./sources/app/meal-menu/state.js